import { HttpHandler } from './HttpHandler';
import { environment } from '../enviroments';
import { OnBoarding, OnBoardingInfo, OnBoardingQuestion } from '../redux/onBoarding/types';
import { SpecialistReview } from '@mindly/ui-components';

export const getOnBoardingByKey = async (key: string) => {
  const request = await HttpHandler({
    method: 'GET',
    url: `${environment.ONBOARDING_URL}/onboarding-key/${key}`,
  });

  return request.data as OnBoarding;
};

export const getOnBoardingQuestionById = async (id: string) => {
  const request = await HttpHandler({
    method: 'GET',
    url: `${environment.ONBOARDING_URL}/question/${id}`,
  });

  return request.data as OnBoardingQuestion;
};

export const getOnBoardingInfoById = async (id: string) => {
  const request = await HttpHandler({
    method: 'GET',
    url: `${environment.ONBOARDING_URL}/info/${id}`,
  });

  return request.data as OnBoardingInfo;
};

export const getOnBoardingReviews = async (
  limit: number,
  offset: number,
  locale = 'uk'
): Promise<SpecialistReview[]> => {
  const { data: reviewsData } = await HttpHandler({
    method: 'GET',
    url: `${environment.SPECIALIST_APP_URL}/reviews/client/onboarding?show_on_onboarding=equal:true&orderBy=created_at.desc&client_country=equal:${locale}&limit=${limit}&offset=${offset}`,
  });

  return reviewsData.data;
};
